import {
  getInitialOnboardingStatus,
  type OrganizationDomainQueryModel,
  OrganizationId,
  OrganizationTypes,
  OrganizationUrn,
} from '@mntn-dev/domain-types'
import { getRandomItem } from '@mntn-dev/utilities'

import { MockModel } from './mock-model.ts'

export const MockOrganization = MockModel<OrganizationDomainQueryModel>(
  ({
    organizationId = OrganizationId(),
    organizationUrn = OrganizationUrn(organizationId),
    organizationType = getRandomItem(OrganizationTypes),
    name = `Organization ${organizationId}`,
    description = `Description ${organizationId}`,
    billingProfiles = undefined,
    partnerPrograms = undefined,
    isPayable = false,
    onboarding = {
      status: getInitialOnboardingStatus(organizationType),
      stepsCompleted: [],
    },
    websiteUrl = 'https://example.com',
    isBlocked = false,
    isArchived = false,
    isFlaggedForRemoval = false,
    isActive = !(isBlocked || isArchived),
  }) => {
    return {
      organizationId,
      organizationUrn,
      organizationType,
      name,
      description,
      onboarding,
      billingProfiles,
      partnerPrograms,
      isPayable,
      websiteUrl,
      isActive,
      isBlocked,
      isArchived,
      isFlaggedForRemoval,
    } satisfies OrganizationDomainQueryModel
  }
)
